module.exports = __webpack_public_path__ + "img/34babc9.png";